"use client";
import {
  __async
} from "../chunk-M66XENHI.js";
import { getPortalBaseURL } from "@getpara/core-sdk";
import { handleMessage } from "./worker.js";
function setupWorker(ctx, resFunction, errorFunction) {
  return __async(this, null, function* () {
    const onmessage = (event) => {
      if (event.data.functionType === "CUSTOM") {
        return;
      }
      resFunction(event.data);
    };
    const onerror = (error) => {
      errorFunction(error);
    };
    if (ctx.disableWorkers) {
      const syncWorker = {
        postMessage: function(message) {
          (function() {
            return __async(this, null, function* () {
              try {
                yield handleMessage({ data: message }, (data) => onmessage({ data }), ctx.disableWorkers);
              } catch (error) {
                onerror(error);
              }
            });
          })();
        },
        terminate: () => {
          return;
        }
      };
      return syncWorker;
    }
    let worker;
    if (ctx.useLocalFiles) {
      throw new Error("useLocalFiles only supported locally");
    } else {
      const workerRes = yield fetch(`${getPortalBaseURL(ctx)}/static/js/mpcWorker-bundle.js`);
      const workerBlob = new Blob([yield workerRes.text()], { type: "application/javascript" });
      const workerScriptURL = URL.createObjectURL(workerBlob);
      worker = new Worker(workerScriptURL);
    }
    worker.onmessage = onmessage;
    worker.onerror = onerror;
    return worker;
  });
}
export {
  setupWorker
};
